function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.92893 17.2132C6.83418 21.1184 13.1658 21.1184 17.0711 17.2132C20.9763 13.308 20.9763 6.97631 17.0711 3.07107C13.1658 -0.834175 6.83418 -0.834175 2.92893 3.07107C-0.976311 6.97631 -0.976311 13.308 2.92893 17.2132ZM15.0508 5.09138C15.4493 5.48987 15.4493 6.13596 15.0508 6.53445L11.4431 10.1421L15.0508 13.7498C15.4493 14.1483 15.4493 14.7944 15.0508 15.1929C14.6523 15.5914 14.0062 15.5914 13.6077 15.1929L10 11.5852L6.39231 15.1929C5.99382 15.5914 5.34773 15.5914 4.94924 15.1929C4.55075 14.7944 4.55075 14.1483 4.94924 13.7498L8.55693 10.1421L4.94924 6.53445C4.55074 6.13595 4.55074 5.48987 4.94924 5.09137C5.34773 4.69288 5.99382 4.69288 6.39231 5.09137L10 8.69906L13.6077 5.09138C14.0062 4.69288 14.6523 4.69288 15.0508 5.09138Z",
  fill: "#646464"
});

const SvgCloseCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-circle.51060904.svg";
export { ForwardRef as ReactComponent };